import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: calc(100% - 10px);
  box-sizing: border-box;
  padding: 5px;
  overflow: hidden;
`

export const BodyDrawer = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  .campo__dois__inputs {
    display: flex;
    gap: 10px;
  }
  .campo__dois__inputs__logo {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .header {
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
    background-color: rgb(224, 224, 224);
  }

  .upload__icone {
    font-size: 14px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    padding: 10px;
    color: white;
    border-radius: 5px;
    opacity: 0;
    transition: 0.1s;
  }

  .avatar__profile {
    width: 80px;
    height: 80px;
    text-align: center;
    cursor: pointer;
    filter: brightness(0.9);
    transition: 0.1s;
  }

  .div__teste {
    position: relative;
  }

  .div__teste:hover .avatar__profile {
    filter: brightness(0.3);
    transition: 0.3s;
  }

  .div__teste:hover .upload__icone {
    opacity: 1;
    transition: 0.3s;
  }

`
